module.exports = __webpack_public_path__ + "img/Weapon_119.312290ba.png";